module.exports = __webpack_public_path__ + "static/media/img_5.483612a3.JPG";